// Stage progress of a production order.
// A routing stage can have more than one work order (the original plus rework), so progress is
// counted per stage number, not per work order.

export const isReworkWorkOrder = (wo: any) =>
  String(wo?.type || '').toUpperCase() === 'REWORK' || /[—-]\s*rework\s*$/i.test(String(wo?.stage_name || ''));

export function getStageProgress(workOrders: any[] | null | undefined) {
  const byStage = new Map<string, any[]>();
  (Array.isArray(workOrders) ? workOrders : []).forEach((wo, index) => {
    const key = String(wo?.stage_number ?? wo?.stageNumber ?? `wo-${index}`);
    byStage.set(key, [...(byStage.get(key) || []), wo]);
  });

  let completed = 0;
  byStage.forEach((wos) => {
    const reworkDone = wos.some((wo) => wo.status === 'COMPLETED' && isReworkWorkOrder(wo));
    // A work order that failed QC no longer holds the stage back once its rework is completed
    const done = wos.every((wo) => wo.status === 'COMPLETED' || (wo.status === 'QC_FAILED' && reworkDone));
    if (done) completed++;
  });

  return { total: byStage.size, completed };
}
